import { useI18n } from "@/contexts/I18nContext";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

export default function LanguageToggle({ size = "default" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className="inline-flex items-center gap-1 rounded-full bg-white border border-slate-200 p-1 shadow-sm" data-testid="lang-toggle">
      <button
        onClick={() => setLang("en")}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${lang === "en" ? "bg-sky-500 text-white" : "text-slate-600 hover:bg-slate-100"}`}
        data-testid="lang-en"
      >EN</button>
      <button
        onClick={() => setLang("hi")}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${lang === "hi" ? "bg-emerald-500 text-white" : "text-slate-600 hover:bg-slate-100"}`}
        data-testid="lang-hi"
      >हिं</button>
    </div>
  );
}
